import React from 'react';
import PropTypes from 'prop-types';

import Select from '../../../../common/select';
import AdminActionButton from '../../../shared/Buttons/AdminActionButton';
import { CsvPreview, HeadersList } from '../Shared';
import FileInput from '../../../../common/fileInput';
import { fullName } from '../../../../common/helpers/users';

const csvHeaders = ['Client First Name*', 'Client Last Name*', 'Phone*', 'Email*', 'Birthday*', 'Notes'];

const CustomersImport = ({
  onChange,
  preview,
  onSubmit,
  barbers,
  handleSubmit,
  deleteImportedCustomers,
  showImportFor,
  deleteAllCustomers,
}) => (
  <div className="c-wrapper">
    <div className="u-max-width-710 u-margin-auto">
      <div className="c-inner-wrapper u-pt">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="layout">
            <div className="layout__item u-1/2 u-p-0">
              <div className="layout__item">
                <FileInput name="csv" onChange={onChange} />
              </div>
              <div className="layout__item u-6/7" display-if={showImportFor}>
                Import for:
                <Select
                  name="barberId"
                  options={barbers}
                  valueField="id"
                  textField={barber => fullName(barber)}
                  empty="Shop"
                  className="c-select u-width-100"
                />
              </div>
              <div className="layout__item u-6/7">
                <AdminActionButton type="submit" className="c-btn c-btn--medium u-width-100">
                  Import clients
                </AdminActionButton>
              </div>
              <div className="layout__item u-6/7">
                <AdminActionButton
                  type="button"
                  className="c-btn c-btn--medium u-width-100"
                  onClick={deleteImportedCustomers}
                >
                  Wipe imported clients
                </AdminActionButton>
              </div>
              <div className="layout__item u-6/7">
                <AdminActionButton
                  type="button"
                  className="c-btn c-btn--medium u-width-100"
                  onClick={deleteAllCustomers}
                >
                  Wipe all clients
                </AdminActionButton>
              </div>
            </div>
            <HeadersList
              fields={csvHeaders}
              className="layout__item u-1/2"
              showMaxLimit
            />
          </div>
        </form>
        <CsvPreview display-if={preview} preview={preview} />
      </div>
    </div>
  </div>
);

CustomersImport.propTypes = {
  onChange: PropTypes.func.isRequired,
  deleteImportedCustomers: PropTypes.func.isRequired,
  deleteAllCustomers: PropTypes.func.isRequired,
  preview: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  barbers: PropTypes.array.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  showImportFor: PropTypes.bool,
};

CustomersImport.defaultProps = {
  preview: null,
  showImportFor: true,
};

export default CustomersImport;
